import { useEffect, useState } from "react";
import axios from 'axios';
import Slider from './Slider';
import Events from './Events';
import Foros from './Foros';
import Noticias from './Noticias';
import './HomePage.css';
import logo_h from "../../assets/images/radioital_h.png";
import news from "../../assets/images/pullitupriddim.png";

const RES_URL = 'https://radioital.com/api/public/api/games';

const slides = [
  { image: './showcase/ital007.jpg', alt: 'Radioital 007' },
  { image: './showcase/ital008.jpg', alt: 'Radioital 008' },
  { image: './showcase/ital009.jpg', alt: 'Radioital 009' },
  { image: './showcase/ital012.jpg', alt: 'Radioital 012' },
  { image: './showcase/ital013.jpg', alt: 'Radioital 013' },
  { image: './showcase/ital014.jpg', alt: 'Radioital 014' },
  { image: './showcase/ital015.jpg', alt: 'Radioital 015' },
  { image: './showcase/ital016.jpg', alt: 'Radioital 016' },
  { image: './showcase/ital017.jpg', alt: 'Radioital 017' },
  { image: './showcase/ital040.jpg', alt: 'Radioital 040' },
  { image: './showcase/ital041.jpg', alt: 'Radioital 041' },
  { image: './showcase/ital052.jpg', alt: 'Radioital 052' },
  { image: './showcase/ital_420_2024_1.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_2.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_3.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_4.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_5.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_6.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_7.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_9.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_11.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_12.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_13.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_14.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_15.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_16.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_17.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_18.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_19.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_20.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_21.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_22.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_23.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_24.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_25.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_26.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_27.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_28.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_29.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_30.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_31.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_32.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_33.jpg', alt: 'Radioital 4/20 2024' },
  { image: './showcase/ital_420_2024_34.jpg', alt: 'Radioital 4/20 2024' },
];

const evnts = [
  //{ image: './events/empress_menen_2025_final.jpg', alt: 'CelebraZion Natalicio #134 Empress Menen Asfaw', date: '5 de Abril 2025, 9am', place: 'Parque Entre Nubes, Bogotá - Colombia' },
  { image: './events/doncarlos.jpg', alt: 'Green Valley Celebrando 20 Años', date: '15 de Mayo 2025, 6pm - 9pm', place: 'Sonora Social Club, Calle 49 # 7-27, Bogotá - Colombia' },
];
const HomePage = () => {
  const [resultados, setResultados] = useState(null);
  const [show, setShow] = useState(false);
  const handleTableClose = (e) => {
    setShow(false);
  };
  useEffect(() => {
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.get(RES_URL, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then((res) => setResultados(res.data.data));
  }, []);
  return (
    <div className="home-page">
      <div hidden={!show}>
        <div
          className="modal-background"
        >
          <div className="modal-card">
            <div className="game_results">
            { resultados ? (
                <div className="results">
                  <h4>Mejores Resultados</h4>
                  <table className="table table-responsive">
                    <thead>
                      <tr className='content-slider'>
                        <th>Puntaje</th>
                        <th>Nombre</th>
                      </tr>
                    </thead>
                    <tbody>
                    {resultados.map((sld, indexq) => (
                      <tr key={indexq}>
                        <td>{sld.pnts_rsltd}</td>
                        <td>{sld.usrio_rsltd}</td>
                      </tr>
                    ))}
                    </tbody>
                  </table>
                </div>
              ) : ('') }
              <div className='buttons_modal2'>
                <button
                  className="btn_cntct"
                  onClick={handleTableClose}  
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-content">
        <div className="home-parts">
          <div className="home-events">
            <h2 className='shows-title'>Comunidad</h2>
            <div className='events_body'>
              <div className='body_in'>
                <h3>Eventos</h3>
                <Events />
                <hr/>
                <h3>Tu Opinión</h3>
                <Foros />
              </div>
            </div>
          </div>
          <div className="home-slides">
            <h2 className='shows-title'>Cubrimientos Especiales</h2>
            <div className="slides-body">
              <Slider slides={slides} />
            </div>
            <div className='showcase-body'>
              <img src={logo_h} alt="logo RadioItal" />
              <h3>En la radio independiente, estamos en busqueda de personas que se identifiquen con la misión y visión; fotografos, escritores, artistas y gestores culturales que quieran ser parte de la gran familia RadioItal. </h3>
              <a className='btn_cntct' rel="noreferrer" href='https://wa.link/pe2ac7' target='_blank'>¡Contactar!</a>
            </div>
          </div>
          <div className="home-news">
            <h2 className='shows-title'>Actualidad</h2>
            <div className="news_body">
              <div className='body_in'>
                <h3>Noticias</h3>
                <div className="noticias">
                  <Noticias />
                </div>
                <hr/>
                <h3>Entretenimiento</h3>
                <div className="game">
                  <iframe src="/game/index.html"></iframe>
                </div>
                <div className="btn_rsltds">
                  <button
                    className="btn_cntct"
                    onClick={() => setShow(true)}  
                  >
                    Ver mejores resultados
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
